import React from 'react';
import { CheckCheck, Check, Clock } from 'lucide-react';
import '../Chat.scss';

const MessageBubble = ({ message, isOwn, showAvatar = true }) => {
  const getStatusIcon = () => {
    if (!isOwn) return null;
    
    if (message.isRead) {
      return <CheckCheck size={14} className="message-bubble__status--read" />;
    }
    return <Check size={14} className="message-bubble__status--sent" />;
  };

  const formatTime = (date) => {
    return new Date(date).toLocaleTimeString('pt-BR', {
      hour: '2-digit',
      minute: '2-digit'
    });
  };

  return (
    <div className={`message-bubble ${isOwn ? 'message-bubble--own' : 'message-bubble--other'}`}>
      {!isOwn && showAvatar && (
        <div className="message-bubble__avatar">
          {message.senderAvatar ? (
            <img src={message.senderAvatar} alt={message.senderName} />
          ) : (
            <span>{message.senderName?.charAt(0).toUpperCase()}</span>
          )}
        </div>
      )}

      <div className="message-bubble__content">
        {!isOwn && (
          <span className="message-bubble__sender">{message.senderName}</span>
        )}
        
        <div className="message-bubble__text">
          {message.message}
        </div>
        
        <div className="message-bubble__footer">
          <span className="message-bubble__time">{formatTime(message.createdAt)}</span>
          {getStatusIcon()}
        </div>
      </div>
    </div>
  );
};

export default MessageBubble;